
<template>
  <div class="card">
    <slot></slot>
  </div>
</template>

<script>
	export default {
    name: 'testcomponent',
		components: {
		},
    props: [

    ],
    methods: {
      
    },
    created() {
      
    },
    mounted() {
     
    }
}
</script>



// WEBPACK FOOTER //
// src/components/containers/container-card.vue